import { Injectable } from '@angular/core';


@Injectable()
export class JwtService {
  
  idToken: String = '';

  getToken(): String {
    return this.idToken;
  }

  saveToken(token: String) {
    this.idToken = token;
  }

  // destroyToken() {
  //   window.localStorage.removeItem('jwtToken');
  // }

}
